import { Group, ActionIcon, Anchor } from '@mantine/core';
import { IconBrandDiscord } from '@tabler/icons-react';
import { useState } from 'react';
import { FAQPopup } from './faq';
import { TermsPopup } from './terms';
import { PrivacyPopup } from './privacy';

export const Footer = () => {
  const [faqOpened, setFaqOpened] = useState(false);
  const [termsOpened, setTermsOpened] = useState(false);
  const [privacyOpened, setPrivacyOpened] = useState(false);

  return (
    <>
      <Group justify="center">
        <Anchor component="button" onClick={() => setFaqOpened(true)} c="dimmed" size="md">
          FAQ
        </Anchor>
        <ActionIcon
          component="a"
          href="https://discord.gg/EddGgGUuWC"
          target="_blank"
          rel="noopener noreferrer"
          variant="subtle"
        >
          <IconBrandDiscord size={20} />
        </ActionIcon>
      </Group>
      <FAQPopup opened={faqOpened} onClose={() => setFaqOpened(false)} />
      <TermsPopup opened={termsOpened} onClose={() => setTermsOpened(false)} />
      <PrivacyPopup opened={privacyOpened} onClose={() => setPrivacyOpened(false)} />
    </>
  );
};
